/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from "react";
import {RouterView, LoadingViewState} from "../RouterView";
import * as _ from "lodash";
import {RouteComponentProps} from "react-router";
import {UserGroup} from "../../http/protocol";
import {getContainer} from "../../ioc/IOCSetup";
import {withRouter} from "react-router";
import {UserGroupService} from "../../services/UserGroupService";
import {DeleteButtonModal} from "../../util/DeleteButtonModal";
import {ErrorModal} from "../../util/ErrorModal";
import { ConfirmModal } from "../../util/ConfirmModal";


export interface State extends LoadingViewState {
    userGroup? : UserGroup;
    categories? : string[];
    descriptions?:any;
    error: boolean;
    errorMessage?: string;
    modalSaveCategories?: boolean;
}
interface Props extends RouteComponentProps {

}
const initialState : State = { loading : true, userGroup : { groupPermissions : {} }, categories : [], descriptions:{}, error:false, errorMessage:""};
export class UserGroupView  extends RouterView<Props ,State>{
    userGroupService : UserGroupService;
    constructor(props : Props) {
        super(props);
        this.state = initialState;
        this.userGroupService = getContainer().getUserGroupService();
    }
    loadContent() : Promise<any> | undefined{
        if((this.props.match.params as any).id !== "new") {
            return Promise.all<any>([
                    this.userGroupService.getEntity((this.props.match.params as any).id),
                    this.userGroupService.listPermissionCategories(),
                    this.userGroupService.listPermissionDescriptionCategory(),
                ]
            ).then(results => {
                this.setState({userGroup: (results[0] as UserGroup), categories: results[1] as string[], descriptions:results[2] as any});
            });
        } else {
            return undefined;
        }
    }
    componentDidUpdate(prevProps : Props, prevState : any) {
        if((prevProps.match.params as any).id !== (this.props.match.params as any).id){
            this.setState(initialState);
            this.refreshContent();
        }
    }

    isEnabled(category : string) {

        if(!this.state.userGroup || !this.state.userGroup.groupPermissions) {
            return false;
        }

        for(let cat in this.state.userGroup.groupPermissions) {
            //let gp : boolean = this.state.userGroup.groupPermissions[cat]
            if(cat === category) {
                return true;
            }
        }
        return false;
    }
    hasWriteAccess(category : string) {
         if(!this.state.userGroup) {
             return false;
         }
         let enabled = this.isEnabled(category);
         if(!enabled) {
             return false;
         }

        var groupAccess = this.state.userGroup.groupPermissions;
        for(var key in groupAccess) {
            let gp : boolean = groupAccess[key];
            if(key === category && gp === true) {
                return true;
            }
        }
        return false;
    }
    getTitle() {
        return "Edit User Group"
    }
    togglePath( cat : string) {
        if(!this.state.userGroup || !this.state.userGroup.groupPermissions) {
            return;
        }
        var userGroup = _.cloneDeep(this.state.userGroup);

        if(userGroup && userGroup.groupPermissions) {
            if(userGroup.groupPermissions[cat]!==undefined) {
                delete userGroup.groupPermissions[cat];
            } else {
                userGroup.groupPermissions[cat] = false;

            }
        }

        this.setState({userGroup : userGroup});
    }
    toggleWriteAccess( cat : string) {
        if(!this.state.userGroup || !this.state.userGroup.groupPermissions) {
            return;
        }
        var userGroup : UserGroup = _.cloneDeep(this.state.userGroup);

        if(userGroup && userGroup.groupPermissions) {
            if(userGroup.groupPermissions[cat]) {
                userGroup.groupPermissions[cat] = !userGroup.groupPermissions[cat]
            } else {
                userGroup.groupPermissions[cat] = true;
            }
        }


        this.setState({userGroup : userGroup});
    }

    getCategories() {
        if(this.state.categories == null || this.state.descriptions == null) {
            return [];
        }
        return this.state.categories.map( (category : string) => {
         
            return (

                <tr key={category}>
                    <td><input type="checkbox" onClick={this.togglePath.bind(this,category)} checked={this.isEnabled(category)}/></td>
                    <td><input type="checkbox" onClick={this.toggleWriteAccess.bind(this,category)} checked={this.hasWriteAccess(category)}/></td>
                    <td>{category}</td>
                    <td>{this.state.descriptions![category]}</td>
                </tr>

            );

        })
    }
    clearAll() {
        let ug = _.cloneDeep(this.state.userGroup);
        if(ug && ug.groupPermissions) {
            ug.groupPermissions = {};
            this.setState({userGroup : ug});
        }

    }

    onSubmit(){
        if(this.state.userGroup) {
            return this.userGroupService.save(this.state.userGroup).then( (userGroup : UserGroup) => {
                if((this.props.match.params as any).id === "new") {
                    this.navigate("/admin/user-group/"+userGroup.id);
                } else {
                    this.setState({ userGroup : userGroup, modalSaveCategories:true })
                }
            }).catch((error)=>{
                console.error("Unable to save user group", this.state.userGroup);
                this.setState({error:true, errorMessage: error.message});
            });
        }
    }
    update(name : string, event : React.FormEvent) {
        var ug = _.clone(this.state.userGroup);
        if(ug) {
            _.set(ug, name, (event.target as any).value);
            this.setState({ userGroup : ug });
        }

    }

    closeModal(){
        this.setState({error:false})
    }

    closeModalSaveCategories(){
        this.setState({modalSaveCategories:false})
    }

    renderContent() {
        if(!this.state.userGroup) {
            return <span></span>
        }
        return (

                <form className="form-horizontal">

                    <div className="row">
                        <div className="col-lg-12">
                          <div className={"card-box"}>
                              <h5>{this.state.userGroup.name}</h5>
                              <div className="form-group">
                                  <label>Name</label>
                                  <input type="text" value={this.state.userGroup.name} onChange={this.update.bind(this,"name")} className="form-control"/>

                              </div>
                              {this.state.userGroup.id && (
                                  <div className="form-group">
                                      <label>Id</label>
                                      <input type="text" readOnly={true} disabled={true} value={this.state.userGroup.id} onChange={this.update.bind(this,"id")}  className="form-control"/>
                                  </div>
                              )}
                          </div>
                        </div>
                    </div>



                    {(this.props.match.params as any).id !== "new" && (
                        <div className="row">
                            <div className="col-lg-12">
                                <div className={"card-box"}>
                                    <h5>Available Categories</h5>
                                    <a className="btn btn-primary" onClick={this.clearAll.bind(this)}>Clear All</a>
                                    <table className="table table-striped mb-0">
                                        <thead>
                                        <tr>
                                            <th style={{width: "100px"}}>Read Access</th>
                                            <th style={{width: "100px"}}>Write Access</th>
                                            <th>Permission</th>
                                            <th>Description</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.getCategories()}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        )
                    }


                    <div className="row">
                        <div className="col-lg-12">
                          <div className={"card-box"}>                           
                              <h5>Apply Changes</h5>
                              <ErrorModal
                                show={this.state.error}
                                hideCancelButton={true}
                                heading="Oops, something went bonker!"
                                description={this.state.errorMessage ||`Oops, something went bonker!`}
                                okLabel="OK"
                                onOk={
                                    this.closeModal.bind(this)
                                }
                                onCancel={this.closeModal.bind(this)}
                                />
                              <div className="form-group">
                                  <DeleteButtonModal className={"btn btn-primary"} onDelete={()=>this.onSubmit()} label={"Save"}/>
                              </div>
                              <div className="form-group">
                                <ConfirmModal
                                        show={this.state.modalSaveCategories}
                                        heading="User Group Categories"
                                        description={`The changes have been saved`}
                                        okLabel="OK"
                                        onOk={
                                            this.closeModalSaveCategories.bind(this)
                                        }
                                        onCancel={this.closeModalSaveCategories.bind(this)}
                                        hideCancelButton={true}
                                    />
                                </div>
                          </div>
                        </div>
                    </div>                       
                </form>

        );
    }


}

export default withRouter(UserGroupView)